import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import scheme from '@/components/scheme'
import modeling from '@/components/modeling'
import coordinates from '@/components/coordinates'
import cases from '@/components/cases'
import PanoramicLive from '@/components/PanoramicLive'
import Participation from '@/components/Participation'

Vue.use(Router)

export default new Router({

  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/scheme',
      name: 'scheme',
      component: scheme
    },
    {
      path: '/modeling',
      name: 'modeling',
      component: modeling
    },
    {
      path: '/coordinates',
      name: 'coordinates',
      component: coordinates
    },
    {
      path: '/cases',
      name: 'cases',
      component: cases
    },
    {
      path: '/PanoramicLive',
      name: 'PanoramicLive',
      component: PanoramicLive
    },
    {
      path: '/Participation',
      name: 'Participation',
      component: Participation
    },
    {
      path: '*',
      name: 'index',
      component: index
    }
  ],
  // mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js